import React from 'react';
import { useTranslation } from 'react-i18next';
import { MoneyIcon } from './Icons';
import { Proposition } from './Proposition';

export const ZeroPlatformFeesProposition = () => {
  const { t } = useTranslation('common', { useSuspense: false });
  return (
    <Proposition
      message={t('fundraising.proposition.message.zeroPlatformFees')}
    >
      <MoneyIcon />
    </Proposition>
  );
};
